var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"absolute":""}},[_c('v-row',{staticClass:"pr-0",staticStyle:{"border":"1px solid red"}},[_c('v-col',{staticClass:"lighten-2 py-4 text-center white--text",staticStyle:{"background-color":"#72B84C","letter-spacing":"1px"}},[_vm._v(" "+_vm._s(new Date().getFullYear())+" — "),_c('strong',[_vm._v(" AgroClimate ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }